import BaseStorageService from './base';

const DATAMANAGE_STORAGE_KEY = 'data_manage';

/**
 * data_manage存储格式
 * {
 *   [user_id]: {
 *     essential_data: true,
 *     performance_data: false,
 *     functionality_data: false,
 *     targeting_data: false,
 *   }
 * }
 */

class DataManageStorage extends BaseStorageService {
  setLocalManageData(data: { settings: Record<string, boolean>; userId: number }) {
    const { userId, settings } = data;
    let obj = this.getItem(DATAMANAGE_STORAGE_KEY);

    if (obj) {
      if (obj[userId]) {
        obj[userId] = { ...settings };
      } else {
        obj[userId] = { ...settings };
      }
    } else {
      obj = {
        [userId]: { ...settings },
      };
    }

    this.setItem(DATAMANAGE_STORAGE_KEY, obj);
  }

  getLocalManageData(userId: number) {
    if (!userId) return;

    const history = this.getItem(DATAMANAGE_STORAGE_KEY);
    if (!history) return null;
    return history[userId];
  }

  clearLocalManageData(userId: number) {
    if (userId) {
      const history = this.getItem(DATAMANAGE_STORAGE_KEY);
      if (history) {
        delete history[userId];
        this.setItem(DATAMANAGE_STORAGE_KEY, history);
      }
    } else {
      this.removeItem(DATAMANAGE_STORAGE_KEY);
    }
  }
}

export default DataManageStorage;
